
export default {
	install(Vue, options) {
		Vue.prototype.$formatNumber = function(num, locale = null, compact = true) {
			// do nothing for null
			if (!num && num !== 0) {
				return
			} else if (num == 'X') {
				return num
			}
			// If 4 digits or less, no formatting is applied (no commas)
			if (num < 10000) {
				return num.toString()
			}

			if (!locale) {
				locale = window.navigator.language || 'en-US'
			}

			// if 5 digits or less, localize, but do not compact
			if (num < 100000) {
				return new Intl.NumberFormat(locale).format(num)
			}
			// if not compact return formatted number
			if (compact) {
				// compact and localize, using 3 sig digits if over 1 million, and 4 otherwise.
				const sigificantDigits = num >= 1000000 ? 3 : 4
				return new Intl.NumberFormat(locale, {
					notation: 'compact',
					compactDisplay: 'short',
					maximumSignificantDigits: sigificantDigits,
				}).format(num)
			} else {
				return new Intl.NumberFormat(locale).format(num)
			}
		}
	}
};
